import { getBusinessObject, is } from 'bpmn-js/lib/util/ModelUtil'

export function getSistemivRaciExtension(element) {
  const businessObject = getBusinessObject(element)
  return getExtension(businessObject, 'sistemiv:Raci')
}

export function getRoles(element) {
  const raci = getSistemivRaciExtension(element)
  return raci && raci.get('roles')
}

export function getExtension(element, type) {
  if (!element.extensionElements) {
    return null
  }

  return element.extensionElements.values.filter(function (e) {
    return e.$instanceOf(type)
  })[0]
}

export function createElement(elementType, properties, parent, factory) {
  const element = factory.create(elementType, properties)

  if (parent) {
    element.$parent = parent
  }

  return element
}

export function createRaci(properties, parent, bpmnFactory) {
  return createElement('sistemiv:Raci', properties, parent, bpmnFactory)
}

export function isNotSupported(element) {
  // Must exist and be a shape (not a connection/arrow)
  if (!element || element.waypoints) return true

  // Allow FlowNodes and Process elements only
  return !is(element, 'bpmn:FlowNode') && !is(element, 'bpmn:Process')
}
